<template>
	<div class="creditHour">
		<navBar>{{ isDui ? '兑换学分' : title }}</navBar>
		<div class="content-box" v-show="!isDui">
			<div class="topnva df-sb df-a">
				<div class="font28 df-c df-d" style="height: 100%">
					<div>
						{{title}}：
						<span class="font30 mCc">{{ userscore }}</span>
					</div>
					<div style="margin-top: 0.25rem" v-if="isXue">
						可兑换芯币：
						<span class="font30 mCc">{{ keduicoin }}</span>
					</div>
				</div>
				<div class="bnt font24 df-mc mCf" v-if="isXue" @click="isDui = true">去兑换</div>
				<div class="bnt font24 df-mc mCf" v-else @click="goPage('/gift')">兑换礼品</div>
			</div>
			<div class="jilu font22">
				<p class="font24">学分记录</p>
				<div class="list">
					<div class="item df-a" v-if="isXue">
						<div class="item1 tac">编号</div>
						<div class="item2 tac">日期</div>
						<div class="item3 tac">单元名称</div>
						<div class="item4 tac">学分</div>
					</div>
					<div class="item df-a" v-else>
						<div class="item1 tac">编号</div>
						<div class="item2 tac">日期</div>
						<div class="item3 tac">类型</div>
						<div class="item4 tac">学分</div>
					</div>
					<div class="item df-a" v-for="(item, i) in listData" :key="item.id + 'yy' + i">
						<div class="item1 tac">{{ i + 1 }}</div>
						<div class="item2 tac">{{ item.createtime.slice(0, 10) }}</div>
						<div class="item3 tac">{{ item.chaptername || item.typetext }}</div>
						<div class="item4 tac">{{ item.score }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="duihuan" v-show="isDui">
			<p class="font28">
				可兑换学分：
				<span class="font32 mCc">{{ userscore }}</span>
			</p>
			<div class="textConetn mCG font24">
				<van-cell-group>
					<van-field
						v-model="valueScore"
						style="padding: 10px 16px 10px 0px"
						placeholder="请输入需要兑换的芯币"
						type="number"
					/>
				</van-cell-group>
			</div>
			<div class="bnt font34 mCf df-mc" @click="scoretocoin">确认兑换</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'creditHour',
	watch: {},
	data() {
		return {
			title: this.$route.query.title || '我的学分',
			icon3: require('../../assets/img/study/icon-3.png'),
			icon4: require('../../assets/img/study/icon-4.png'),
			icon5: require('../../assets/img/study/icon-5.png'),
			navList: [{ name: '创意礼品' }, { name: '图书礼品' }, { name: '生活日用' }],
			isDui: false,
			isXue: this.$route.query.title == '我的学分' ? true : false,
			keduicoin: '',
			userscore: '',
			listData: [],
			valueScore: null
		};
	},
	created() {
		this.$route.query.title == '我的学分' ? this.getscorelist() : this.getcoinlist();
	},
	methods: {
		getscorelist() {
			this.$api.getscorelist().then((res) => {
				this.keduicoin = res.data.keduicoin;
				this.userscore = res.data.userscore;
				this.listData = res.data.scorelog.data;
			});
		},
		getcoinlist() {
			this.$api.getcoinlist().then((res) => {
				this.userscore = res.data.usercoin;
				this.listData = res.data.coinlog.data;
			});
		},
		scoretocoin() {
			if (this.valueScore != '' && this.valueScore > 0 && this.valueScore <= this.keduicoin) {
				this.$api.scoretocoin({ coin: this.valueScore }).then((res) => {
					if (res.code == 1) {
						this.$toast({
							message: res.msg
						});
						setTimeout(() => {
							this.getscorelist();
							this.isDui = false;
						}, 1000);
					}
				});
			}else{
				this.$toast({
					message: '请输入正确可兑换芯币'
				});
			}
		},
		goPage(path) {
			this.$router.push({
				path: path,
				query: {
					id: 45,
					name: 'name',
					active: 1
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.creditHour {
	height: calc(100% - 1.08rem);
	padding: 0.34rem 0.28rem 0.28rem 0.28rem;
	position: fixed;
	left: 0;
	right: 0;
	top: 1.08rem;
	overflow: auto;
	background: #f5faff;
	.content-box {
		position: relative;
		padding-bottom: 0.2rem;
		.topnva {
			width: 100%;
			height: 1.92rem;
			background: #fdf5f2;
			padding: 0.4rem 0.28rem;
			.bnt {
				width: 1.52rem;
				height: 0.52rem;
				background: #ff7a32;
				border-radius: 0.26rem;
			}
		}
		.jilu {
			width: 100%;
			height: calc(100% - 2.2rem);
			padding: 0.28rem;
			background: #fff;
			margin-top: 0.28rem;

			.list {
				width: 100%;
				border: 1px solid #dcdcdc;
				margin-top: 0.28rem;
				color: #909090;
				.item {
					height: 0.7rem;
					border-bottom: 1px solid #dcdcdc;
					&:last-child {
						border: none;
					}
					&:first-child {
						background: #f3f3f3;
					}
					.item1 {
						width: 20%;
					}
					.item2 {
						width: 30%;
					}
					.item3 {
						width: 25%;
					}
					.item4 {
						width: 25%;
					}
				}
			}
		}
	}
	.duihuan {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 11;
		padding: 0.28rem;
		.textConetn {
			width: 100%;
			height: 1.9rem;
			background-color: #fff;
			padding: 0.36rem 0.28rem;
			margin-top: 0.3rem;
		}
		.bnt {
			width: calc(100% - 0.56rem);
			height: 0.88rem;
			margin-left: 0.28rem;
			background: #ff7a32;
			border-radius: 0.44rem;
			margin-top: 3.5rem;
		}
		&::v-deep .van-hairline--top-bottom::after {
			border-width: 0px 0;
		}
	}
}
</style>
